export const FREE_DAILY_LIMIT = 3;
export const PRO_DAILY_LIMIT = 100;

export const FREE_MAX_CARDS_PER_GEN = 100;
export const PRO_MAX_CARDS_PER_GEN = 1500;

export const FREE_MAX_TOPIC_LENGTH = 5000;
export const PRO_MAX_TOPIC_LENGTH = 10000;

export const FREE_MAX_FILE_SIZE_MB = 2;
export const PRO_MAX_FILE_SIZE_MB = 10;

export const STRIPE_ENABLED = process.env.REACT_APP_STRIPE_ENABLED === 'true';

export const STRIPE_CUSTOMERS_COLLECTION = 'stripe_customers';

export const getCustomerDocPath = (uid: string) => `${STRIPE_CUSTOMERS_COLLECTION}/${uid}`;
export const getCheckoutSessionsCollectionPath = (uid: string) => `${STRIPE_CUSTOMERS_COLLECTION}/${uid}/checkout_sessions`;
export const getSubscriptionsCollectionPath = (uid: string) => `${STRIPE_CUSTOMERS_COLLECTION}/${uid}/subscriptions`;